import React, { useState } from 'react';
import { Box, Paper, TextField, Button, Typography, CircularProgress, Alert } from '@mui/material';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import { useAuth } from '../../contexts/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(email, password);
    } catch {
      setError('Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(150deg, #0d0d14 0%, #171422 55%, #1d1526 100%)',
      position: 'relative', overflow: 'hidden',
      p: 2,
    }}>
      {/* Warm ember glow behind the card */}
      <Box sx={{
        position: 'absolute', width: 520, height: 520, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,112,67,0.14) 0%, transparent 65%)',
        top: '50%', left: '50%', transform: 'translate(-50%, -58%)',
        pointerEvents: 'none',
      }} />
      <Paper sx={{
        p: 4, width: '100%', maxWidth: 400,
        bgcolor: 'rgba(22,22,42,0.85)', backdropFilter: 'blur(8px)',
        border: '1px solid rgba(255,112,67,0.2)',
        boxShadow: '0 24px 64px rgba(0,0,0,0.5)',
      }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box sx={{
            width: 56, height: 56, borderRadius: '50%', bgcolor: 'rgba(255,112,67,0.15)',
            border: '1px solid rgba(255,112,67,0.25)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2,
          }}>
            <RestaurantIcon sx={{ color: 'primary.main', fontSize: 28 }} />
          </Box>
          <Typography variant="h5">FoodList</Typography>
          <Typography variant="body2" color="text.secondary"
            sx={{ mt: 0.5, fontFamily: '"Fraunces", serif', fontStyle: 'italic' }}>
            every place worth eating at
          </Typography>
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} required fullWidth autoComplete="email" />
          <TextField label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} required fullWidth autoComplete="current-password" />
          <Button type="submit" variant="contained" size="large" disabled={loading} fullWidth>
            {loading ? <CircularProgress size={22} color="inherit" /> : 'Sign In'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
